<script setup>
import { cdnImageUrl } from '@/front/composables/ImageComposer.js'
const props = defineProps({
  ann:{
    type: Object,
    required: true
  }
})

const isVariableImageContent = computed(() => {
  return typeof props.ann?.content === 'string' && props.ann.content.includes('{{')
})

const imageVariablePreview = computed(() => {
  if (!isVariableImageContent.value) {
    return ''
  }
  return props.ann.content.trim()
})

</script>

<template>
  
  <div class="grid grid-cols-1 text-center bg-black/10 p-2 rounded-lg">
    <div
      v-if="isVariableImageContent"
      class="layer-image mx-auto flex items-center justify-center text-sm text-gray-700 font-mono break-all"
    >
      {{ imageVariablePreview }}
    </div>
    <img v-else class="layer-image mx-auto block" :src="cdnImageUrl(ann.content)"/>
  </div>
  <div v-if="ann.caption || ann.extra" class="text-sm mt-2" v-html="ann.transformed_caption || ann.caption || ann.extra"> 
      
  </div>

</template>

<style scoped>
  .layer-image {
    max-height: 80px;
    max-width: 100%;
    min-height: 48px;
    /* max-width: 80px; */
  }
</style>
